<nav class="link-nav" [attr.aria-label]="ariaLabel">
  <a
    *ngFor="let item of items; trackBy: trackByIndex"
    href="javascript:void(0)"
    class="link-nav-item"
    [class.active]="isActive(item.value)"
    (click)="onItemSelect(item.value)"
  >
    {{ item.label }}
  </a>
</nav>
